import { IUploadImage } from '@Domains/UploadImage';

export const mapAssets = (
  assets: IUploadImage[] | null | undefined
): IUploadImage[] | undefined => {
  if (!assets) {
    return undefined;
  }

  const processedAssetFiles = assets.map((asset: IUploadImage) => ({
    id: asset.id ?? null,
    ...asset,
  }));

  return processedAssetFiles.length > 0 ? processedAssetFiles : [];
};
